// src/store/rootReducer.ts
import { combineReducers } from 'redux';
import organizerReducer from './organizer/reducer';

export const rootReducer = combineReducers({
  organizer: organizerReducer,
});

export type RootState = ReturnType<typeof rootReducer>;
